export const GROUP_BASE_PRICE_UPDATING = 'GROUP_BASE_PRICE_UPDATING';
export type GROUP_BASE_PRICE_UPDATING = typeof GROUP_BASE_PRICE_UPDATING;

export const GROUP_BASE_PRICE_UPDATED = 'GROUP_BASE_PRICE_UPDATED';
export type GROUP_BASE_PRICE_UPDATED = typeof GROUP_BASE_PRICE_UPDATED;

export const GROUP_BASE_PRICE_RECEIVED = 'GROUP_BASE_PRICE_RECEIVED';
export type GROUP_BASE_PRICE_RECEIVED = typeof GROUP_BASE_PRICE_RECEIVED;
